import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import LearningResourceScreen from '../screen'


const LearningResourcesRoutes = () => {
    return (
        <React.Fragment>
            <Route exact path={CLIENT_ENDPOINTS.LEARNING_RESOURCE} component={LearningResourceScreen} />
        </React.Fragment>
    )
}

export default LearningResourcesRoutes